import React, { Component } from "react";
import { connect } from "react-redux";

import MovieTheater from '../movietheaters/containers/movietheater.component';
import MovieTheaterDetails from '../movietheaters/containers/movietheatersdetails.component';
import { getMovieTheatersWithTickets, getMovieTheatersWithTicketsSeeMore } from '../../../SHARED/actions/movietheaters.actions';
import { API_URL } from "../../../SHARED/config/apiEndpoints";
import Pagination from "../../../SHARED/components/pagination/pagination.component";
import MapWithContainer from "../../../SHARED/components/maps/mapwithcontainer";
import Spinner from '../../../SHARED/components/spinner/spinner.component';
import { pageViewEvent, slugify } from "../../../SHARED/helpers/general.helper";
import { Helmet } from "react-helmet";

class Tickets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            itemsPerPage: 10,
            resultsPerPageList: [10, 20, 30],
            showMap: false,
            selectedCinema: {}
        };
    }

    componentWillMount() {
        window.scrollTo(0, 0);
        this.props.getMovieTheatersWithTickets(0);
    }

    componentDidMount() {
        pageViewEvent('Bilete - Cinemap',window.location.href)
     }

    componentWillReceiveProps(nextProps) {
        if (this.props.selectedCinemaLocation !== nextProps.selectedCinemaLocation) {
            // this.getData(0, this.state.itemsPerPage, nextProps.selectedCinemaLocation);
            pageViewEvent('Bilete - Cinemap',window.location.href)
            window.scrollTo(0, 0);
            this.props.getMovieTheatersWithTickets(0);
        }
    }


    getDataByChangingPage(currentPage, itemsPerPage) {
        this.setState({
            itemsPerPage: itemsPerPage
        }, () => {
            this.getData(currentPage, this.state.itemsPerPage, this.props.selectedCinemaLocation);
        });
    }

    getCinemaImagesURL(defaultImage, images) {
        let cinemaImagesURL = [];
        if (images.length !== 0) {
            cinemaImagesURL.push({ article_image: defaultImage });
            images.forEach(imageURL => {
                cinemaImagesURL.push({ article_image: imageURL });
            });
        }
        else if (defaultImage) {
            cinemaImagesURL.push({ article_image: defaultImage });
        }

        return cinemaImagesURL;
    }

    navigateToSchedule(movieTheater) {
        const path = '/program/' + movieTheater.movieTheater.cinema_id + '/' + slugify(movieTheater.movieTheater.cinema_name);
        this.props.history.push(path);
    }

    showMap(item) {
        this.setState({
            showMap: true,
            selectedCinema: item.movieTheater
        });
    }

    hideMap() {
        this.setState({
            showMap: false
        });
    }

    showMovieTheaters(movieTheater) {
        return (
            <div key={movieTheater.cinema_id} className="movie-theater-container row no-gatters">
                <div className="col-lg-4 col-xl-4">
                    <MovieTheater images={this.getCinemaImagesURL(movieTheater.cinema_image, movieTheater.cinema_image_gallery)} />
                </div>
                <div className="col-lg-8 col-xl-8">
                    <MovieTheaterDetails
                        id={movieTheater.cinema_id}
                        uuid={movieTheater.cinema_uuid}
                        name={movieTheater.cinema_name}
                        address={movieTheater.cinema_address_street + ', ' + movieTheater.cinema_address_locality}
                        halls={movieTheater.cinema_nr_of_rooms}
                        phone={movieTheater.cinema_telephone}
                        email={movieTheater.cinema_email}
                        site={movieTheater.cinema_website}
                        favorite="none"
                        description=""
                        showMap={this.showMap.bind(this, { movieTheater })}
                    />
                </div>

                <div className="col-lg-12 text-right">
                    <button className="movie-schedule" onClick={this.navigateToSchedule.bind(this, { movieTheater })}>VEZI PROGRAMUL FILMELOR</button>
                </div>
            </div>
        );
    }

    seeMore = () => {
        this.props.getMovieTheatersWithTicketsSeeMore(this.props.paginatedData.pager.current_page + 1);
    }

    getSeeMoreCondition = () => {
        if (this.props.paginatedData) {
            if (this.props.paginatedData.rows && this.props.paginatedData.pager) {
                return <span onClick={this.seeMore}>
                    {this.props.paginatedData.rows.length !== this.props.paginatedData.pager.total_items ? "Vezi mai multe..." : ""}
                </span>
            }
        }
    }

    // getSeeMoreCondition = () => {
    //     if (this.props.paginatedData){
    //         if(this.props.paginatedData.rows && this.props.paginatedData.pager){
    //             return <span className="see-more" onClick={this.seeMore}>
    //                 {this.props.paginatedData.rows.length !== this.props.paginatedData.pager.total_items ? 
    //                         <Pagination totalItems={this.props.paginatedData.pager.total_pages}
    //                             itemsPerPage={this.state.itemsPerPage}
    //                             resultsPerPageList={this.state.resultsPerPageList}
    //                             getDataByChangingPage={this.getDataByChangingPage.bind(this)} /> : "" }
    //             </span>
    //         }
    //     }
    // }

    render() {
        return (
            <div className="movie-theaters-container">
                <Helmet>
                    <title>Bilete - Cinemap</title>
                    <meta name="description" content="Bilete"/>
                    <link rel="canonical" href={window.location.href}/>
                </Helmet>
                {this.props.loading !== 0 ? <Spinner /> : ''}
                <span className="title">CINEMATOGRAFE - CUMPĂRĂ BILETE</span>
                {this.props.paginatedData && this.props.paginatedData.rows.map(this.showMovieTheaters, this)}
                <div className="col see-more">
                    {this.getSeeMoreCondition()}
                </div>
                <div className="pagination-container row">
                    {this.props.paginatedData && this.props.paginatedData.rows && this.props.paginatedData.rows.length === 0 && <div className="schedule-no-results">Fara rezultate</div>}
                </div>
                {this.state.showMap && <MapWithContainer
                    coordinates={this.state.selectedCinema.cinema_geolocation}
                    title={this.state.selectedCinema.cinema_name}
                    address={this.state.selectedCinema.cinema_address_street + ', ' + this.state.selectedCinema.cinema_address_locality + ', ' + this.state.selectedCinema.cinema_address_postal_code}
                    phone={this.state.selectedCinema.cinema_telephone}
                    closeMap={this.hideMap.bind(this)}
                />}
            </div >
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    paginatedData: state.movieTheaters.movieTheatersTickets.paginatedData,
    selectedCinemaLocation: state.filters.selectedCinemaLocation
});

export default connect(mapStateToProps, { getMovieTheatersWithTickets, getMovieTheatersWithTicketsSeeMore })(Tickets);


// WEBPACK FOOTER //
// ./src/FO/components/tickets/tickets.component.js